import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

const REASONS = [["harassment", "Harassment or bullying"], ["spam", "Spam or scams"], ["impersonation", "Pretending to be someone else"], ["inappropriate", "Inappropriate name or photo"], ["other", "Something else"]];

export function ReportDialog({ member, onClose, onSubmit }) {
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onSubmit({ reason, details: details.trim() || null });
    setBusy(false);
    if (ok) onClose();
  };
  return (
    <Dialog open={!!member} onOpenChange={o => !o && onClose()}>
      <DialogContent className="max-w-md bg-white" data-testid="report-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="fs-serif text-2xl">Report {member?.display_name}</DialogTitle>
            <DialogDescription>Our team sees only this member's name and photo, your name, and what you write here.</DialogDescription>
          </DialogHeader>
          <fieldset className="my-4 space-y-2">
            <legend className="text-xs tracking-widest uppercase fs-accent mb-2">Reason</legend>
            {REASONS.map(([v, label]) => (
              <label key={v} className="flex items-center gap-3 text-sm cursor-pointer">
                <input type="radio" name="report-reason" value={v} checked={reason === v} onChange={() => setReason(v)} style={{ accentColor: "#B6A46D" }} data-testid={`report-reason-${v}`} />{label}
              </label>
            ))}
          </fieldset>
          <label className="block text-xs fs-text-2 mb-1" htmlFor="report-details">Details (optional)</label>
          <textarea id="report-details" className="fs-input w-full" rows={3} maxLength={1000} value={details} onChange={e => setDetails(e.target.value)} data-testid="report-details" />
          <DialogFooter className="mt-4 gap-2">
            <button type="button" className="fs-btn-2" onClick={onClose} data-testid="report-cancel">Cancel</button>
            <button type="submit" className="fs-btn" disabled={!reason || busy} data-testid="report-submit">Send report</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function ConfirmDialog({ confirm, onClose }) {
  return (
    <AlertDialog open={!!confirm} onOpenChange={o => !o && onClose()}>
      <AlertDialogContent className="max-w-md bg-white" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="fs-serif text-2xl">{confirm?.title}</AlertDialogTitle>
          <AlertDialogDescription>{confirm?.body}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel className="fs-btn-2" data-testid="confirm-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction className="fs-btn" onClick={() => { confirm.run(); onClose(); }} data-testid="confirm-ok">{confirm?.cta}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
